import { Globe, ExternalLink } from "lucide-react";

interface DiscussionLinkPreviewProps {
  linkUrl: string;
  compact?: boolean;
}

export function DiscussionLinkPreview({ linkUrl, compact }: DiscussionLinkPreviewProps) {
  if (compact) {
    return (
      <a
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
        onClick={(e) => e.stopPropagation()}
      >
        <Globe className="h-3 w-3" />
        <span className="truncate max-w-[150px]">
          {linkUrl.replace(/^https?:\/\//, "")}
        </span>
      </a>
    );
  }

  return (
    <a
      href={linkUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-3 flex items-center gap-3 p-3 rounded-lg border border-border bg-muted/50 hover:bg-muted transition-colors no-underline"
      onClick={(e) => e.stopPropagation()}
    >
      <Globe className="h-5 w-5 text-muted-foreground flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground truncate">
          {linkUrl.replace(/^https?:\/\//, "")}
        </p>
        <p className="text-xs text-muted-foreground">Visit website</p>
      </div>
      <ExternalLink className="h-4 w-4 text-muted-foreground flex-shrink-0" />
    </a>
  );
}
